import React, { useEffect, useState, useCallback } from "react";
import { Col, Container, Row } from "react-bootstrap";
import BlogCard from "../components/common/blog-card";
import blogService from "../services/blog-services";
import Pagination from "../components/common/Pagination";
import { handleErrors } from "../utils/errorHandler";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";

const BlogPage = () => {
  const [blogList, setBlogList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cPage, setCPage] = useState(1);
  const [pageS, setPageS] = useState(12);

  const fetchBlogs = useCallback(async () => {
    setLoading(true);
    const payload = {
      pageSize: pageS,
      pageNo: cPage,
      fiterParam: "",
      sortBy: "",
    };

    try {
      const response = await blogService.getBlogListing(payload);
      setBlogList(response.data.result || []);
    } catch (error) {
      const errorMessage = handleErrors(error);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [cPage, pageS]);

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  const handlePageChange = (newPage) => {
    setCPage(newPage);
  };

  return (
    <>
      <section className="innerpage-banner">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="inner-banner-title">
                <h1>Blogs</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="blog-page-section">
        <Container>
          <Row className="row row-gap-gutter">
            {error ? (
              <ErrorHandlingDesign errorMessage={error} />
            ) : loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {blogList?.map((blogItem, index) => (
                  <Col xl={3} lg={4} md={4} sm={6} key={`blog-${index}`}>
                    <BlogCard blogItem={blogItem} />
                  </Col>
                ))}

                {blogList.length > 0 && (
                  <Col lg={12}>
                    <div className="grid-pagination">
                      <Pagination
                        onPageChange={handlePageChange}
                        pageS={pageS}
                        cPage={cPage}
                        pCount={blogList[0]?.totalCount}
                      />
                    </div>
                  </Col>
                )}
              </>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BlogPage;
